import axios from 'axios'
import { useFormik } from 'formik'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import * as Yup from 'yup';
import { CompanyContext } from '../../../Context/CompanyContext.js'
import { useParams } from 'react-router-dom'

export default function AddNewPrice() {
   const {testId} = useParams() ;
   const navigate = useNavigate() ;
   const [loading , setLoading] = useState(false);
   const{allCompanyInfo  , getAllCompanyInfo} = useContext(CompanyContext)
   
   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${localStorage.getItem("token") }` 
   } ;



   async function submitAddTest(values){
      setLoading(true);
      let response =   await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/price` , values , {headers:header})
      .catch((error)=>{
         setLoading(false);
         Swal.fire({
            title:error.response.data.message  ,
            text: "Please Try Again" ,   
            icon: "error"
            });
      });

      if(response?.data.message === "success"){
         setLoading(false);
         Swal.fire({
            title:response?.data.message  ,
            text:"Success Added New Price" ,   
            icon: "success"
         });
         navigate(`/dashBoard/specificTest/${testId}`)
      }
   }



   let validationSchema = Yup.object({
      company:Yup.string().max(24 , "Company less than 14").required("Company is Required") ,
      price:Yup.number().required() ,
      priceAfterDiscount:Yup.number().required() ,
      final_amount:Yup.number().required() ,
   })



   let formik = useFormik({
      initialValues:{
         price:"" ,
         priceAfterDiscount:"" ,
         final_amount:"" ,
         test: testId ,
         company:"" ,
      } , validationSchema , 
      onSubmit:submitAddTest
   })


   useEffect(() => {
      getAllCompanyInfo() ;
   }, [])
   

   return (
      <Fragment>
         <div className="w-75 p-2 m-auto mt-5">
            <h1 className="main-header">Add New Price</h1>
            <div className='under-header'></div>

            <form action="" onSubmit={formik.handleSubmit}>

               <div className="my-4">
                  <label htmlFor="company" className="form-label">Enter Company</label>
                  <select name="company" id="company"  className="form-control"
                        onChange={formik.handleChange} 
                        onBlur={formik.handleBlur} 
                        value={formik.values.company} >

                     <option value="">Select Company</option>
                     {allCompanyInfo.map((ele)=>{
                        return (
                           <option value={ele._id}>{ele.name}</option>
                        )
                     })}      
                  </select>

                  {formik.errors.company && formik.touched.company?<div className="alert alert-danger mt-4 p-2">{formik.errors.company}</div> :""}
               </div>


               <div className="my-4">
                  <label htmlFor="price" className="form-label">Enter Price</label>
                  <input type="number" 
                     value={formik.values.price}
                     onChange={formik.handleChange} 
                     onBlur={formik.handleBlur}
                     className="form-control" id="price"  
                     name="price" 
                     placeholder="Enter Price" />
                  {formik.errors.price && formik.touched.price?<div className="alert alert-danger mt-4 p-2">{formik.errors.price}</div> :""}
               </div>


               <div className="my-4">
                  <label htmlFor="priceAfterDiscount" className="form-label">Enter Price After Discount</label>
                  <input type="number" 
                     value={formik.values.priceAfterDiscount}
                     onChange={formik.handleChange} 
                     onBlur={formik.handleBlur}
                     className="form-control" id="priceAfterDiscount"  
                     name="priceAfterDiscount" 
                     placeholder="Price After Discount" />
                  {formik.errors.priceAfterDiscount && formik.touched.priceAfterDiscount?<div className="alert alert-danger mt-4 p-2">{formik.errors.priceAfterDiscount}</div> :""}
               </div>


               <div className="my-4">
                  <label htmlFor="final_amount" className="form-label">Contract Price</label>
                  <input type="number" 
                     value={formik.values.final_amount}
                     onChange={formik.handleChange} 
                     onBlur={formik.handleBlur}
                     className="form-control" id="final_amount"  
                     name="final_amount" 
                     placeholder="Contract Price" />
                  {formik.errors.final_amount && formik.touched.final_amount?<div className="alert alert-danger mt-4 p-2">{formik.errors.final_amount}</div> :""}
               </div>


               <div className="d-grid gap-2 col-6 mx-auto">
                  {loading? 
                        <button className="btn bg-main text-white btn-sm mt-2"> <i className="fa-solid fa-spinner fa-spin fa-rotate-180 fa-xl"></i></button> 
                     :
                        <button disabled={!(formik.isValid && formik.dirty)} type="submit" className="btn bg-main text-white btn-sm mt-2">Add Price</button>
                  }
               </div>

            </form>

         </div>
      </Fragment>
   )
}